<template>
  <div class="flex w-full">
    <div class="mx-auto text-center">
      <div class="ml-[47%]">
        <LayoutPanelLeft class="w-12 h-12" />
      </div>
      <div class="mt-4 text-2xl dark:text-white">
        {{ $t("Welcome to your Forecasting Page") }}
      </div>
      <div class="mt-2 text-common-grey">
        {{ $t("All the pages are hidden. Use the") }}
        <Settings2 color="grey" class="w-4 inline h-4 mx-1" /> {{ $t("icon in the Side Menu to show pages.") }}
      </div>
    </div>
  </div>
</template>

<script>
import { LayoutPanelLeft, Settings2 } from "lucide-vue-next"

export default {
  components: {
    LayoutPanelLeft,
    Settings2
  },

  emits: [],
  data() {
    return {}
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
